export default {
  intro: {
    default: 'Wprowadź dane osoby podpisującej umowę.',
    gbr: 'Wprowadź dane wspólnika podpisującego umowę.',
    gmbh: 'Wprowadź dane właściciela lub dyrektora zarządzającego podpisującego umowę.',
  },
  sections: {
    home_address: 'Adres zamieszkania',
    home_address_help: 'Miejsce zamieszkania tej osoby, a nie adres restauracji.',
  },
  form: {
    owner_first_name: {
      label: 'Imię',
      placeholder: 'Wprowadź imię',
    },
    owner_last_name: {
      label: 'Nazwisko',
      placeholder: 'Wprowadź nazwisko',
    },
    owner_dob: {
      label: 'Data urodzenia',
      placeholder: 'Data',
    },
    owner_phone_number: {
      label: 'Telefon',
    },
    owner_email: {
      label: 'E-mail',
      placeholder: 'Wprowadź adres e-mail',
      help: 'Może być inny niż e-mail, za pomocą którego się logujesz.',
    },
    owner_id_number: {
      label: 'Numer identyfikacyjny (np. numer ubezpieczenia społecznego w USA)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Wstecz',
    next: 'Dalej',
  },
};
